import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { CODE8_TYPE } from 'constants/config'
import Mask from 'vanilla-masker'

class OccurrencesCode8ViewContent extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    titleText: PropTypes.string.isRequired,
    subText: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    subtitle: PropTypes.string.isRequired,
    titleList: PropTypes.string.isRequired,
    listSections: PropTypes.array.isRequired,
    typeContent: PropTypes.number.isRequired,
  }

  state = {
    percent: '',
    currency: '',
    sizeCurrency: '',
    formatCurrency: {
      separator: '',
      delimiter: '',
    },
  }

  componentDidMount() {
    const { translate } = this.props

    this.setState({
      percent: translate('option.percent'),
      currency: translate('option.currency'),
      sizeCurrency: translate('size.currency'),
      formatCurrency: {
        separator: translate('separator.currency'),
        delimiter: translate('delimiter.currency'),
      },
    })
  }

  renderSector = (sector, index) => {
    const { typeContent } = this.props

    let { value } = sector
    let valuePrinted
    let percentPrinted

    switch (typeContent) {
      case CODE8_TYPE.LMS:
        valuePrinted = sector.valuePrinted
        const percentPrintedValue = sector.percentPrinted || 0

        percentPrinted =
          Mask.toMoney(
            percentPrintedValue
              ? percentPrintedValue.toFixed(this.state.sizeCurrency)
              : 0,
            this.state.formatCurrency
          ) + this.state.percent
        break
      case CODE8_TYPE.SALES:
        value =
          this.state.currency +
          Mask.toMoney(
            value ? value.toFixed(this.state.sizeCurrency) : 0,
            this.state.formatCurrency
          )
        break
      default:
        break
    }

    let percent = sector.percent || 0
    percent =
      Mask.toMoney(
        percent ? percent.toFixed(this.state.sizeCurrency) : 0,
        this.state.formatCurrency
      ) + this.state.percent

    return (
      <tr key={index}>
        <td>{`${sector.sectionId ? `${sector.sectionId} - ` : ''}${
          sector.sectionDescription || ''
        }`}</td>
        <td className='align-right'>{value}</td>
        <td className='align-right'>{percent}</td>
        {typeContent === CODE8_TYPE.LMS && (
          <td className='align-right'>{valuePrinted}</td>
        )}
        {typeContent === CODE8_TYPE.LMS && (
          <td className='align-right'>{percentPrinted}</td>
        )}
      </tr>
    )
  }

  render() {
    const {
      titleText,
      subText,
      value,
      subtitle,
      titleList,
      listSections,
      translate,
      typeContent,
    } = this.props

    let dataLabel = ''
    let valueLabel = ''
    let dataPrintedLabel = ''

    switch (typeContent) {
      case CODE8_TYPE.LMS:
        dataLabel = translate('occurrences-code8.section')
        valueLabel = translate('occurrences-code8.lmQuantity')
        dataPrintedLabel = translate('occurrences-code8.section.printed')
        break
      case CODE8_TYPE.SALES:
        dataLabel = translate('occurrences-code8.section')
        valueLabel = translate('occurrences-code8.estimatedLoss').replace(
          '{0}',
          this.state.currency
        )
        break
      default:
        break
    }

    return (
      <div className='rectangle no-margin rounded'>
        <h4 className='heading-4 uppercase title'>{titleText}</h4>
        <div>
          <span className='highlighted-number'>{value}</span>
          <span className='subtext'>{subText}</span>
          <br />
        </div>
        <p className='text'>{subtitle}</p>
        <p className='text bold'>{titleList}</p>

        <table className='table table-striped'>
          <thead>
            <tr>
              <th>{dataLabel}</th>
              <th className='align-right'>{valueLabel}</th>
              <th className='align-right'>{this.state.percent}</th>
              {typeContent === CODE8_TYPE.LMS && (
                <th className='align-right'>{dataPrintedLabel}</th>
              )}
              {typeContent === CODE8_TYPE.LMS && (
                <th className='align-right'>{this.state.percent}</th>
              )}
            </tr>
          </thead>
          <tbody>
            {listSections ? listSections.map(this.renderSector) : ''}
          </tbody>
        </table>
      </div>
    )
  }
}

export default OccurrencesCode8ViewContent

export { OccurrencesCode8ViewContent }
